import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import TransactionAppResource from "./TransactionAppResource";

export const BUYER = '15973a91-9e6f-4b55-a8d4-043de0169440';
export const SELLER = '63692203-bce8-49ab-af08-f169b0c24ec8';
export const BUYER_AND_SELLER = '80e84ff7-3f52-4aa6-8080-52245998a165';
export const RENTAL = '520076d7-dfcf-49f7-b0e6-0f47abd625aa';
export const DEAL = 'bb875302-d061-4eef-aec2-077647a9ad5f';

export const ALL = {
    BUYER,
    SELLER,
    BUYER_AND_SELLER,
    RENTAL,
    DEAL,
};

class LuTransactionTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-transaction-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/transaction/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            transactions: TransactionAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            }
        };
    }

}

export default LuTransactionTypeAppResource;
